import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface Props {
  logo: string;
  title: string;
  count?: number;
  className?: string;
  renderDesc?: (() => JSX.Element | string) | string;
  renderFooter?: () => JSX.Element | null;
  renderLabels?: () => JSX.Element;
}
const MyMaterialItem: React.FC<Props> = ({
  logo,
  title,
  className,
  renderDesc,
  renderFooter,
  renderLabels,
  count
}) => (
  <div
    className={classNames(
      styles.container,
      className,
      renderDesc && styles.large
    )}
  >
    <div className={styles.logo}>
      <img src={logo} alt="" />
      {count && <div className={styles.count}>{count}</div>}
    </div>
    <div className={styles.name}>{title}</div>
    {renderDesc && (
      <div className={styles.desc}>
        {typeof renderDesc === 'string' ? renderDesc : renderDesc()}
      </div>
    )}

    {renderLabels && renderLabels()}
    {renderFooter && renderFooter()}
  </div>
);

export default MyMaterialItem;
